import EditPanel from './EditPanel';

export default EditPanel;
